import { formatDistanceToNow } from "date-fns";
import { arSA, enUS } from "date-fns/locale";
import { useTranslation } from "react-i18next";

import {
  getAgentProfileRoute,
  getCoachProfileRoute,
  getEntityProfileRoute,
  getOtherProfileRoute,
  getPlayerProfileRoute,
  getScoutProfileRoute,
} from "../../../routers/routeUtils";

import { formatMediaUrl } from "../../../utils/formatters/formatMedia";

import { Comment } from "../types/types";

export const useCommentFormatter = (comment?: Comment) => {
  const { t, i18n } = useTranslation("common");
  const currentLang = i18n.language;
  const selectedLocale = currentLang === "ar" ? arSA : enUS;

  if (!comment) return undefined;

  const timeAgo = formatDistanceToNow(new Date(comment.createdAt), {
    addSuffix: true,
    locale: selectedLocale,
  });

  const { author } = comment;
  const authorLink = author.entity
    ? getEntityProfileRoute(author.entity.id)
    : author.role === "PLAYER"
    ? getPlayerProfileRoute(author?.id || "")
    : author.role === "AGENT"
    ? getAgentProfileRoute(author?.id || "")
    : author.role === "SCOUT"
    ? getScoutProfileRoute(author?.id || "")
    : author.role === "COACH"
    ? getCoachProfileRoute(author?.id || "")
    : getOtherProfileRoute(author?.id || "");

  return {
    ...comment,
    authorFullName: `${author.firstName} ${author.lastName}`.trim(),
    authorMedia: formatMediaUrl(author?.media?.url || author?.entity?.mediaUrl || ""),
    authorFirstTwoChr: `${author.firstName?.slice(0, 1).toUpperCase()}${author.lastName?.slice(0, 1).toUpperCase()}`,
    authorRole: author.role ? t(`user.role.${author.role}`) : author.subRole ? t(`user.role.${author.subRole}`) : null,
    authorLink,
    authorClub: null,
    timeAgo,
  };
};
